// 03e — submitted.
import { Icon } from '../../lib/icons';

export function DoneStep({ onEditAgain }: { onEditAgain: () => void }) {
  return (
    <div
      style={{
        background: 'var(--deeper)',
        border: '1px solid var(--cyan)',
        borderRadius: 16,
        padding: '24px 20px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <Icon name="check" size={44} color="var(--cyan)" style={{ flex: 'none' }} />
        <div
          style={{
            fontSize: 'clamp(28px,7vw,34px)',
            fontWeight: 900,
            letterSpacing: '-0.03em',
            lineHeight: 1.05,
            color: 'var(--cyan)',
          }}
        >
          all set. we've got your input.
        </div>
      </div>
      <p style={{ fontSize: 19, lineHeight: 1.55, color: 'var(--body-2)', margin: '12px 0 0' }}>
        nothing else to do until there's a place and a date. that comes by email.
      </p>
      <button
        type="button"
        className="wh-ghost on-card"
        onClick={onEditAgain}
        style={{ minHeight: 56, padding: '0 22px', marginTop: 18, fontSize: 18, display: 'inline-flex' }}
      >
        change my answers
      </button>
    </div>
  );
}
